module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"reason.label.default":"สาเหตุ","confirm.message.default":"คุณต้องการยืนยันการเปลี่ยนแปลงนี้ ?"}}')
  delete Component.options._Ctor
}
